import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-bookings-form',
  templateUrl: './bookings-form.component.html',
  styleUrls: ['./bookings-form.component.scss']
})
export class BookingsFormComponent implements OnInit {
  data: string = '';
  captcha: boolean = false;
  constructor(private router:Router, private activatedRoute: ActivatedRoute, private sanitizer: DomSanitizer) {

  }

  ngOnInit() {

    this.data = this.activatedRoute.snapshot.params.linkId.toLowerCase();
    console.log(this.data);// OUTPUT 1534

  }

  resolved(captchaResponse: string) {
   this.captcha = true;
    console.log(captchaResponse);
  }




}
